// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"7e12882fde14aef524dc","180":"c1b1176fb6ce0b02b7b5","386":"6396bc246dec9e77913a","628":"19d13645795758613286"}[chunkId] + ".css";
};